import React, { Component } from 'react'
import styled from 'styled-components'
import Text from '../components/Text'

const Box = styled.div`
  display: flex;
  align-items: center;
  margin: 1.5rem 0;
  font-size: 1.2rem;
  width: 100%;
  line-height: 175%;
  &:first-child {
    margin-top: 0;
  }
  &:last-child {
    margin-top: 0;
  }
`

const Icon = styled.div`
  border-radius: 1.5rem;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  color: #fff;
  font-size: 1.5rem;
  background: ${props => `var(--${props.color})`};
`

const Content = styled.div`
  flex: 1;
`

export default class SummaryBullet extends Component {
  render() {
    const { str, inserts, icon, color, children } = this.props

    return (
      <Box>
        <Icon className={icon} color={color} />
        <Content>
          {str && <Text str={str} inserts={inserts} />}
          {!str && children}
        </Content>
      </Box>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SummaryBullet.js